import React, { Component } from "react";
import { Helmet } from "react-helmet";
import Logo from "../../components/Logo";

class QbSuccess extends Component {
  constructor(props) {
    super(props);
  }

  onContinueClick = () => {
    let { history } = this.props;
    history.push(`/client/settings`, { openQB: true });
  };

  render() {
    const { heapEmail, heapAppId, appName } = this.props;

    return (
      <div className="sessions fill-screen mg-session">
        <Helmet>
          <title>{appName} | Success</title>
        </Helmet>
        <div className={`sessions-modal modal-space`}>
          <div className="sessions-modal-logo-container centerd-content">
            <Logo circular={true} />
          </div>
          <div className="sessions-modal-content">
            <h1 className="sessions-modal-heading qb-heading-success">
              QuickBooks Online Account Authenticated
            </h1>
            <p className="qb-msg-text">
              The authentication process with QuickBooks Online has completed successfully.
            </p>
          </div>
          <div className="modal-actions qb-btns">
            <a
              className="cta"
              onClick={() => {
                this.onContinueClick();
              }}
            >
              Continue
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default QbSuccess;
